import React, { useEffect, useState } from 'react';
import { Brain, Info, Settings } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { getSupabaseClient, isAdmin } from '../lib/supabase';

export default function Header() {
  const location = useLocation();
  const [isAdminUser, setIsAdminUser] = useState(false);
  const supabase = getSupabaseClient();

  useEffect(() => {
    if (!supabase) return;
    
    // Check if user is admin
    isAdmin().then(setIsAdminUser);

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session) {
        isAdmin().then(setIsAdminUser);
      } else {
        setIsAdminUser(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <header className="bg-indigo-600 text-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <Link to="/" className="flex items-center space-x-2 sm:space-x-3 hover:text-white/90">
            <Brain className="w-8 h-8" />
            <h1 className="text-base sm:text-lg lg:text-xl font-bold">AI POWERBALL PREDICTION GAME</h1>
          </Link>
          <div className="flex items-center space-x-3 sm:space-x-4">
            <Link 
              to="/how-it-works"
              className={`flex items-center space-x-1 sm:space-x-2 text-sm sm:text-base hover:text-white/90 ${
                location.pathname === '/how-it-works' ? 'text-white' : 'text-white/80'
              }`}
            >
              <Info className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>How It Works</span>
            </Link>
            {isAdminUser && (
              <Link 
                to="/admin"
                className={`flex items-center space-x-1 sm:space-x-2 text-sm sm:text-base hover:text-white/90 ${
                  location.pathname === '/admin' ? 'text-white' : 'text-white/80'
                }`}
              >
                <Settings className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>Admin</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}